export default "__VITE_ASSET__BiCst6Uh__"